// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadTeamsFxDevScript = exports.loadPackageJson = void 0;
const tslib_1 = require("tslib");
const fs = tslib_1.__importStar(require("fs-extra"));
const path = tslib_1.__importStar(require("path"));
async function loadPackageJson(path, logger) {
    if (!(await fs.pathExists(path))) {
        logger === null || logger === void 0 ? void 0 : logger.error(`Cannot load package.json from ${path}. File not found.`);
        return undefined;
    }
    const rpj = require("read-package-json-fast");
    try {
        return await rpj(path);
    }
    catch (error) {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        logger === null || logger === void 0 ? void 0 : logger.error(`Cannot load package.json from ${path}. Error: ${error}`);
        return undefined;
    }
}
exports.loadPackageJson = loadPackageJson;
async function loadTeamsFxDevScript(componentRoot) {
    const packageJson = await loadPackageJson(path.join(componentRoot, "package.json"));
    if (packageJson && packageJson.scripts && packageJson.scripts["dev:teamsfx"]) {
        const devTeamsfx = packageJson.scripts["dev:teamsfx"];
        return devTeamsfx;
    }
    else {
        return undefined;
    }
}
exports.loadTeamsFxDevScript = loadTeamsFxDevScript;
//# sourceMappingURL=packageJsonHelper.js.map